import { ReturnsPromise } from 'api/api';

import { TranslateICUFn } from '~src/commons/utils/translations/translate';
import { priceToString } from '~src/price/format';

export const returnAndExchangeMessagesBuilder = (
  translate: TranslateICUFn,
  returnPromise: ReturnsPromise
): string[] => {
  const { currency_code, return_cost, return_time_days } = returnPromise;

  const result: string[] = [];

  if (return_cost && currency_code) {
    result.push(
      translate('widget.EXCHANGE_AND_RETURN.RETURN_COST', {
        return_cost: priceToString(return_cost),
        currency_code,
      })
    );
  }

  if (return_time_days) {
    result.push(translate('widget.EXCHANGE_AND_RETURN.RETURN_TIME', { max: return_time_days }));
  }

  return result;
};
